import apiRequest from '../apis/api-request';
import { selectAuthToken } from '../redux/reducers/authReducers';
import { store } from '../redux/store';

const dashboardService = {

    superAdminDashboard: async (data) => {
        return apiRequest({
            method: "POST",
            url: `/api/dashboard/super-admin`,
            data
        });
    }

};

export default dashboardService;